import {
  useEffect
} from 'react';

export const useInterceptConsoleMessage = (
  triggerCallback: () => void,
  matchText: string
): void => {
  useEffect(() => {
    const originalLog = console.log;

    const interceptedLog = (...args: any[]) => {
      const matched = args.some(
        (arg) => typeof arg === 'string' && arg.includes(matchText)
      );

      if (matched) {
        triggerCallback();
        setTimeout(() => { console.log = originalLog; }, 0);
        return;
      }

      originalLog(...args);
    };

    console.log = interceptedLog;

    return () => {
      console.log = originalLog;
    };
  }, []);
};
